<template>  
  <div>
    <v-tabs v-model="tab">
      <v-tab>Server Data</v-tab>
      <v-tab v-if="statusOffline">Local Data</v-tab>
      <v-spacer/>
      <v-btn v-if="roles.includes('surveyor') || roles.includes('sys_admin')" fab color="green" dark small absolute right :to="{name:'survey/respon/form', query:{jilid_id:$route.query.jilid_id}}"><v-icon>add</v-icon></v-btn>                      
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card>
          <v-toolbar flat>      
            <v-text-field flat dense filled
              v-model="term"
              append-icon="search"
              label="Search"
              single-line
              hide-details        
              @input="search"
              style="max-width:200px"
            ></v-text-field>                             
            <v-btn icon color="blue-grey" :loading="loading" @click="readItems"><v-icon>find_replace</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pa-0">      
            <v-container fluid grid-list-lg class="ma-0 pa-0">
              <v-layout row>
                <v-flex xs12 md12 style="position:relative">            
                  <v-data-table dense 
                    :headers="headers"
                    :items="items"              
                    :loading="loading"
                    loading-text="Loading... Please wait"
                    :items-per-page="-1"
                    hide-default-footer  
                    :options.sync="pagination" 
                    must-sort                       
                  >               
                    <template v-slot:item.no="{ item }">{{ ((page-1)*20)+(items.findIndex(x=>x==item)+1) }}</template>
                    <template v-slot:item.address="{ item }">
                      {{item.address}}, {{item.tps?item.tps.name:''}}, {{item.kecamatan?item.kecamatan.name:''}}, {{item.kabupaten?item.kabupaten.name:''}}
                    </template>
                    <template v-slot:item.action="{ item }">
                      <v-btn v-if="roles.includes('sys_admin')" icon x-small color="green" target="_blank" :to="{name:'survey/respon/print',query:{jilid_id:$route.query.jilid_id,id:item.id}}"><v-icon>print</v-icon></v-btn>
                      <v-btn v-if="roles.includes('surveyor') || roles.includes('sys_admin') " icon x-small color="blue" :to="{name:'survey/respon/form',query:{jilid_id:$route.query.jilid_id,id:item.id}}"><v-icon>edit</v-icon></v-btn>
                      <v-btn v-if="roles.includes('sys_admin')" icon x-small color="red" @click="removeRespon(item)"><v-icon>delete_forever</v-icon></v-btn>
                    </template>              
                  </v-data-table>
                  <div class="text-center">
                    <v-pagination
                      v-model="page"
                      :length="totalPages"
                      circle
                      :total-visible="9"
                    ></v-pagination>
                  </div>
                </v-flex>          
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card> 
      </v-tab-item>
      <v-tab-item>
        <index-local />
      </v-tab-item>
    </v-tabs-items>
  </div>  
</template>

<script>
import { debounce } from 'lodash'
import model from '@/app/models/Respon'
import User  from '@/utils/models/User'
import IndexLocal from './index-local'


export default {
  components:{IndexLocal},
  data () {
    return {
      tab : 0,
      term : null,
      headers:[
        {text:'No', value:'no'},        
        {text:'Date', value:'date', width:120},
        {text:'Code', value:'code'},
        {text:'Name', value:'name'},
        {text:'Phone', value:'phone'},
        {text:'Address', value:'address'},   
        {text:'Surveyor', value:'createdby.username'},     
        {text:'#', value:'action', width:100, align:'right', sortable:false}
      ],
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false,    
      roles : User.roles(),  
    }
  },
  computed:{
    status(){
      return this.$store.getters.DICTIONS.JilidStatus;      
    }, 
    statusOffline(){
      return model.query().first() ? true : false;
    }   
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    }
  },  
  created () {
    this.readItems()
  },
  mounted(){
    this.tab = this.statusOffline ? 1 : 0;
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0) {
      this.loading = true; this.items = [];
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : 'id';                          
      
      const params = {
        perPage: 20,
        page: this.page,
        q: this.term,
        jilid_id: this.$route.query.jilid_id,
        sort:sortby,
        expand:'kecamatan,tps,kelurahan,kabupaten,propinsi,createdby'
      }

      model.index(params)
        .then(response => {
          this.items = response.data;
          this.totalPages = response.pagination ? response.pagination.pageCount : 0;               
          this.loading = false
        })
    },    

    removeRespon(item){
      this.$swal({title: 'Are you sure?', text: "You won't be able to revert this!",
        showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {                 
        if (result.value) {                    
          model.deleteOnline({id:item.id}).then(()=>{          
            this.readItems(); 
          })
        }
      });
    }
  },  
}
</script>